// firestore where in クエリの制限数
export const FIRESTORE_WHERE_IN_LIMIT = 30;
